import React, {useState} from "react";
import {BrowserRouter as Router} from "react-router-dom";

import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import AppWithRouterAccess from './AppWithRouterAccess';
import RegisterNewUser from '../user/RegisterNewUser';

import './App.css';

import Amplify, {Auth} from 'aws-amplify';
import awsconfig from './aws-exports';
import {withAuthenticator} from '@aws-amplify/ui-react';

// Don't deploy 'authenticate = false' to production.
// The production server will correctly respond with unauthorized, so nothing will work in the client.
const authenticate = true;

Amplify.configure(awsconfig);

const App = () => {
    const [me, setMe] = useState(undefined);
    const [newUser, setNewUser] = useState(undefined);

    console.log("App build:", window.REACT_APP_BUILD);

    let server = process.env.REACT_APP_SERVER || window.REACT_APP_SERVER;
    if(server) {
        console.log("App server:", server);
    } else {
        server = "http://localhost:8080";
        console.warn("App default server:", server);
    }

    authenticate && !me && !newUser && Auth.currentAuthenticatedUser().then(info => {
        console.log("App currentAuthenticatedUser:", info);
        getMe({
            id: info.attributes.sub,
            email: info.attributes.email,
        });
    });

    if(!me && newUser) {
        return (
            <div className="register">
                <RegisterNewUser
                    newUser={newUser}
                    onSave={saveNewUser}
                />
            </div>
        );
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Router>
                {authenticate && !me &&
                    "Authenticating user..."
                }
                {authenticate && me &&
                    <AppWithRouterAccess
                        server={server}
                        getAuthorization={getAuthorization}
                        user={me}
                    />
                }
                {!authenticate &&
                    <AppWithRouterAccess
                        server={server}
                        getAuthorization={() => ''}
                        user={{email: 'lars.hoidahl@gmail.com'}}
                    />
                }
            </Router>
        </MuiPickersUtilsProvider>
    );

    function getMe(user) {
        console.log("App getMe user:", user);

        return Auth.currentSession().then(session => {
            let accessToken = session.getAccessToken().getJwtToken();
            /*
            cognito:username: "06dc73cf-6be3-4376-842b-40c1eef4dfa0"
            email: "lars.hoidahl@gmail.com"
             */

            return fetch(server + "/me", {
                headers: {
                    Authorization: 'Bearer ' + accessToken,
                },
            });
        }).then(res => {
            if (res.status === 404) {
                console.log("App: User not defined.");
                return undefined;
            } else if (res.status >= 400) {
                throw new Error("Get me Server returned error " + res.status);
            } else {
                return res.json();
            }
        }).then(me => {
            if(me) {
                console.log("App me:", me);
                setMe(me);
            } else {
                console.log("App register me:", user);
                setNewUser(user);
            }
        });
    }

    function saveNewUser(values) {
        console.log("App saveNewUser", values);

        return Auth.currentSession().then(session => {
            let accessToken = session.getAccessToken().getJwtToken();

            return fetch(`${server}/me`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                    Authorization: 'Bearer ' + accessToken,
                },
                body: JSON.stringify({
                    externalId: values.id,
                    email: values.email,
                    name: values.name,
                }),
            });
        }).then(res => {
            if(res.status >= 400) {
                throw new Error("Register me Server returned error " + res.status);
            } else {
                return res.json();
            }
        }).then(me => {
            console.log("App register me:", me);
            setMe(me);
        });
    }
}

async function getAuthorization() {
    // console.log("App.getAuthorization");
    let session = await Auth.currentSession();
    let accessToken = session.getAccessToken().getJwtToken();
    return 'Bearer ' + accessToken;
}

export default authenticate ? withAuthenticator(App) : App;
